import { useState, useEffect } from "react";
import {ApiUrl} from "../../ApiUrl"
const useFetchStates = () => {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchStates = async () => {
      const apiURL = `${ApiUrl.apiurl}STATE/GetAllState/`;
      try {
        const response = await fetch(apiURL);
        const result = await response.json();
        if (response.ok) {
          setStates(Array.isArray(result?.data) ? result.data : []);
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError("Failed to fetch countries");
        setStates([]);
      } finally {
        setLoading(false);
      }
    };
    fetchStates();
  }, []);
  return { states, loading, error };
};
export default useFetchStates;